import product from '@views/products/view';

export default {
    path: '/products/:slug',
    name: 'products.view',
    component: product
}